// DeleteOrDeactivateAccidentDialog/index.js
import React from 'react';

import DualActionDialog from '../DualActionDialog';
import { branchStatus } from '../../constants';
import { injuryMappers } from '../../mappers';

function DeleteOrDeactivateAccidentDialog(props) {
  const {
    open,
    status,
    accident,
    showDialog,
    onConfirmDeleteDeactivateAccident,
    isSaving,
    errorMessage
  } = props;

  const title = status === branchStatus.DEACTIVE ? 'Deactive' : 'Delete';
  const actionText =
    status === branchStatus.DEACTIVE ? 'Deactiveted' : 'Deleted';

  const injuryType =
    accident && injuryMappers.mapInjuryTypeToText(accident.injuryTypeId);

  const handleConfirmAction = (event) => {
    event.preventDefault();

    const payload = {
      accident,
      status
    };
    onConfirmDeleteDeactivateAccident(payload);
  };

  return (
    <React.Fragment>
      <DualActionDialog
        open={open}
        title={`${title} ${injuryType}`}
        description={`This Accident will be ${actionText.toLowerCase()}. Are you sure you want to ${title.toLocaleLowerCase()}?`}
        actionButtonText={title}
        cancelButtonText="Cancel"
        handleClose={() => showDialog(false, accident, status)}
        handleSubmit={handleConfirmAction}
        showProgressBar={isSaving}
        errorMessage={errorMessage}
        isDanger={true}
      />
    </React.Fragment>
  );
}

export default DeleteOrDeactivateAccidentDialog;
